import { ChangeEvent } from 'react';
import { Input } from 'antd';
import { Button } from '../../../../../../../components/button';
import style from './style.module.scss';

interface SearchComponentProps {
    otherClientId: string;
    setOtherClientId: (value: string) => void;
    handleSearch: () => void;
}

const SearchComponent = ({
    otherClientId,
    setOtherClientId,
    handleSearch,
}: SearchComponentProps) => {
    const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        setOtherClientId(e.target.value);
    };

    return (
        <div className={style.container}>
            <div className={`${style.title} ${style.rightPadding}`}>
                Other Client ID to Swap With
            </div>
            <div className={style.searchContainer}>
                <Input
                    value={otherClientId}
                    onChange={onInputChange}
                    className={style.input}
                    aria-label="Other Client ID"
                />
                <Button variant="primary" onClick={handleSearch}>
                    Search
                </Button>
            </div>
        </div>
    );
};

export default SearchComponent;
